import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  chatBar: {
    backgroundColor: '#F7F7F7',
    display: 'flex',
    padding: theme.spacing(2),
    position: 'relative'
  },
  emojiPicker: {
    position: 'absolute',
    bottom: '72px',
    left: '0',
    right: '0',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#F7F7F7',
    '& .emoji-mart': {
      display: 'flex',
      flexDirection: 'column'
    },
    '& .emoji-mart, .emoji-mart *': {
      flexShrink: 0,
      flexGrow: 0
    },
    '& .emoji-mart-scroll': {
      flexShrink: 1
    }
  },
  emojiPickerContainer: {
    width: '100%'
  },
  emojiPickerWrapper: {
    width: '100%'
  },
  emojiPickerWrapperInner: {
    padding: theme.spacing(2),
    paddingBottom: 0
  },
  chatTextField: {
    flexGrow: 1
  },
  inputRoot: {
    borderRadius: 20,
    borderColor: '#707070'
  },
  inputInput: {
    padding: '10.5px 14px',
    paddingRight: 0
  },
  emojiButton: {
    marginRight: [theme.spacing(-1), '!important']
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  sendButton: {
    height: '100%',
    background: '#333',
    color: 'white',
    textTransform: 'capitalize',
    borderRadius: 20,
    fontSize: 12,
    marginLeft: theme.spacing(),
    '&:hover': {
      backgroundColor: '#696969'
    }
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatBar/styles.js